import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react'
import LoginShell from '../components/LoginShell'

function LoginRedirect() {
  const { authStatus } = useAuthenticator()
  const navigate = useNavigate()

  useEffect(() => {
    if (authStatus === 'authenticated') {
      navigate('/dashboard', { replace: true })
    }
  }, [authStatus, navigate])

  return null
}

export default function LoginPage() {
  return (
    <LoginShell>
      <Authenticator.Provider>
        <LoginRedirect />
        <Authenticator hideSignUp={true} />
      </Authenticator.Provider>
    </LoginShell>
  )
}
